import React, { Component } from 'react'

import PillTabs from '../PillTabs'

// makes the headers equal height
import Equalizer from 'react-equalizer'

import './style.scss'
import MassiveTitle from '../MassiveTitle/index'

export default class PricingTable extends Component {
  constructor(props) {
    super(props)

    this.changeTarget = this.changeTarget.bind(this)
    this.getHeaders = this.getHeaders.bind(this)
  }

  state = {
    targetAudience: this.props.audiences.edges[0],
  }

  changeTarget(target) {
    this.setState({ targetAudience: target })
  }

  getHeaders(count) {
    const headers = Array(count)
      .fill(undefined)
      .map((item, index) => this[`header${index}`])

    return headers
  }

  render() {
    const { data, audiences } = this.props
    const filteredData = data.filter(
      item =>
        item.node.frontmatter.targetAudience ===
        this.state.targetAudience.node.name
    )

    // if there's less than 3 items  wider columns
    const colClass =
      filteredData.length > 2
        ? 'col-md-4'
        : filteredData.length > 1
        ? 'col-md-6'
        : 'col-md-8'
    return (
      <div className="position-relative ">
        <MassiveTitle modifiers={['up']}>Compare</MassiveTitle>
        <div className="container mb-3 mb-lg-5">
          <div className="pl-lg-5">
            <PillTabs
              handleChange={this.changeTarget}
              data={audiences}
              activeItem={this.state.targetAudience}
            />
          </div>
          <Equalizer nodes={() => this.getHeaders(filteredData.length)}>
            <div className="row justify-content-center">
              {filteredData.map((item, index) => (
                <div className={`${colClass} my-2 my-lg-4`} key={item.node.id}>
                  <article className="c-pricing-item">
                    <header
                      ref={n => (this[`header${index}`] = n)}
                      className="text-center bg-light pt-3 pb-4 px-2 position-relative"
                    >
                      <img
                        className="c-pricing-item__icon"
                        src={
                          item.node.frontmatter.icon.childImageSharp.original
                            .src
                        }
                        alt={item.node.frontmatter.title}
                      />
                      <h5 className="c-pricing-item__audience mt-3 mb-1">
                        {item.node.frontmatter.targetAudience}
                      </h5>
                      <h3 className="c-pricing-item__title my-2">
                        {item.node.frontmatter.title}
                      </h3>
                      <h5 className="c-pricing-item__subtitle pt-2">
                        {item.node.frontmatter.subTitle}
                      </h5>
                      <a
                        href={item.node.frontmatter.product_link}
                        className="c-pricing-item__plus bg-flashy position-absolute"
                      >
                        Read more
                      </a>
                    </header>
                    <main className="pt-4 pb-2">
                      <ul className="c-pricing-item__feature-list c-pricing-item__feature-list--enabled">
                        {item.node.frontmatter.enabledFeatures.map(feature => (
                          <li key={feature}>{feature}</li>
                        ))}
                      </ul>
                      {item.node.frontmatter.missingFeatures && (
                        <ul className="c-pricing-item__feature-list c-pricing-item__feature-list--missing">
                          {item.node.frontmatter.missingFeatures.map(
                            feature => (
                              <li key={feature}>{feature}</li>
                            )
                          )}
                        </ul>
                      )}
                    </main>
                    <footer className="c-pricing-item__footer px-4  text-center text-uppercase">
                      <div className="c-pricing-item__footer__inner pt-2">
                        <a
                          href={item.node.frontmatter.product_link}
                          className="text-secondary"
                        >
                          View this product
                        </a>
                      </div>
                    </footer>
                  </article>
                </div>
              ))}
            </div>
          </Equalizer>
        </div>
      </div>
    )
  }
}
